import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { theme, greys } from "@clockwise/web-commons/src/styles/color.styles";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";

// REVIST THESE
const footer: CSSProperties = {
  fontSize: 12,
  padding: "20px 10px 15px 10px",
};

const actions: CSSProperties = {
  display: "flex",
  paddingTop: 10,
};

const actionButton: CSSProperties = {
  minWidth: "55px",
  borderRadius: 20,
  marginRight: 7,
};

const unselectedActionButton: CSSProperties = {
  ...actionButton,
  backgroundColor: greys.paleGrey,
};

const selectedActionButton: CSSProperties = {
  ...actionButton,
  backgroundColor: greys.cloudyBlue,
};

const actionLabel: CSSProperties = {
  borderRadius: 0,
  fontSize: 12,
  color: theme.textSecondary,
  textTransform: "uppercase",
  fontWeight: typeStyles.weight.bold,
};

const feedback: CSSProperties = {
  fontFamily: typeStyles.fontFamilySans,
  color: greys.slate,
};

const cardButtonContainer: CSSProperties = {
  padding: 6,
  borderTop: `1px solid ${greys.borderGrey}`,
};

export const styles = {
  footer,
  actions,
  unselectedActionButton,
  selectedActionButton,
  actionLabel,
  feedback,
  cardButtonContainer,
};
